/**
 * Generated by '@kontent-ai/model-generator@5.2.0'
 *
 * Project name: Sample Project
 * Environment: Production
 * Project Id: 159e78b3-53be-00bf-4a39-4f5211f2ace4
 */
export const contentTypes = {
  /**
   * Hero Unit
   * Last modified: Wed Mar 27 2019 14:06:00 GMT+0100 (Středoevropský standardní čas)
   */
  hero_unit: {
    codename: 'hero_unit',
    id: 'f4deeb7e-fe9b-49a2-a5f6-a51a9be6ac73',
    externalId: undefined,
    name: 'Hero Unit',
    elements: {
      /**
       * Title (text)
       *
       * Provide a title that fits within 60 characters.
       */
      title: {
        codename: 'title',
        id: '16ea3e64-4103-da81-eabd-af7efc2ab8a6',
        externalId: undefined,
        name: 'Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Image (asset)
       *
       * Attach a teaser image; max. dimensions are 1280 × 600 px; allowed formats are *.jpg, *.png, *.gif.
       */
      image: {
        codename: 'image',
        id: '4aeed98e-58d1-ab13-232c-542bf268fe48',
        externalId: undefined,
        name: 'Image',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Marketing message (rich_text)
       *
       * Include a main goal of our business. The limit is 80 characters.
       */
      marketing_message: {
        codename: 'marketing_message',
        id: 'ecf4e55f-1ae0-f539-3516-5714a0f032e9',
        externalId: undefined,
        name: 'Marketing message',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: '0f620d29-a4c7-4944-b7d2-be5de2733b6e',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * Hosted video
   * Last modified: Fri Mar 29 2019 14:55:48 GMT+0100 (Středoevropský standardní čas)
   */
  hosted_video: {
    codename: 'hosted_video',
    id: '269202ad-1d9d-47fd-b3e8-bdb05b3e3cf0',
    externalId: undefined,
    name: 'Hosted video',
    elements: {
      /**
       * Video ID (text)
       */
      video_id: {
        codename: 'video_id',
        id: '116a2441-6441-7124-c85b-46a4fef5dcb9',
        externalId: undefined,
        name: 'Video ID',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Video host (multiple_choice)
       */
      video_host: {
        codename: 'video_host',
        id: '87924912-4861-aa84-176a-1eae7b22529b',
        externalId: undefined,
        name: 'Video host',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * Coffee
   * Last modified: Tue Jul 16 2019 09:18:34 GMT+0200 (Středoevropský letní čas)
   */
  coffee: {
    codename: 'coffee',
    id: '929985ac-4aa5-436b-85a2-94c2d4fbbebd',
    externalId: undefined,
    name: 'Coffee',
    elements: {
      /**
       * Product name (text)
       *
       * Include a product display name.
       */
      product_name: {
        codename: 'product_name',
        id: 'edaec5c4-e653-9109-eb0d-fc40ccf3c810',
        externalId: undefined,
        name: 'Product name',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Price (number)
       *
       * Include a product price.
       */
      price: {
        codename: 'price',
        id: '624592dc-49b2-330a-7185-e1f2396ce90c',
        externalId: undefined,
        name: 'Price',
        required: false,
        type: 'number',
        snippetCodename: undefined,
      },

      /**
       * Image (asset)
       *
       * Upload a product image; the recommended size is 300 × 300 px.
       */
      image: {
        codename: 'image',
        id: '30ac3ccc-1e7f-1490-e1f6-915c64176a55',
        externalId: undefined,
        name: 'Image',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Short description (rich_text)
       *
       * Include a short description that fits within 160 characters.
       */
      short_description: {
        codename: 'short_description',
        id: 'b5a3263a-a1d7-92b7-865a-329f833285fa',
        externalId: undefined,
        name: 'Short description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Long description (rich_text)
       *
       * Include a full product description.
       */
      long_description: {
        codename: 'long_description',
        id: 'd468a0aa-e0fa-0cae-41db-6e006bff2527',
        externalId: undefined,
        name: 'Long description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Product status (taxonomy)
       *
       * Add a product status if the product is included in a special offering.
       */
      product_status: {
        codename: 'product_status',
        id: '1ee64175-fde7-fc1e-5259-511a31c326c3',
        externalId: undefined,
        name: 'Product status',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Farm (text)
       *
       * Include the name of the coffee farm.
       */
      farm: {
        codename: 'farm',
        id: 'e5cf103f-9b84-1ab0-29f1-fb5a1657c6f7',
        externalId: undefined,
        name: 'Farm',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Country (text)
       *
       * Include  the coffee's country of origin.
       */
      country: {
        codename: 'country',
        id: '6eec1918-378d-3b15-8b1a-19c5f0748321',
        externalId: undefined,
        name: 'Country',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Variety (text)
       *
       * Include a coffee variety name.
       */
      variety: {
        codename: 'variety',
        id: '301c6712-962f-b05a-6f6e-2f0e1e959039',
        externalId: undefined,
        name: 'Variety',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Altitude (text)
       *
       * Include the altitude at which the coffee is grown. Elevation affects the size, shape, and taste of coffee beans.
       */
      altitude: {
        codename: 'altitude',
        id: '23a772c0-0b2b-588d-9849-e29068701f03',
        externalId: undefined,
        name: 'Altitude',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * URL pattern (url_slug)
       *
       * Provide a SEO-friendly URL.
       */
      url_pattern: {
        codename: 'url_pattern',
        id: '3af8ce38-c03d-063c-ea80-72684dfddf31',
        externalId: undefined,
        name: 'URL pattern',
        required: false,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * Processing (taxonomy)
       */
      processing: {
        codename: 'processing',
        id: 'b63e3516-d5fa-fdac-a03a-2b027bf02a28',
        externalId: undefined,
        name: 'Processing',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: '99d7a378-e18f-41dd-b5bb-2a569c3d1de7',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Meta title (text)
       *
       * Length: 30–60 characters
       */
      metadata__meta_title: {
        codename: 'metadata__meta_title',
        id: '09398b24-61ed-512e-5b5c-affd54a098e5',
        externalId: undefined,
        name: 'Meta title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * Meta description (text)
       *
       * Length: 70–150 characters
       */
      metadata__meta_description: {
        codename: 'metadata__meta_description',
        id: '2e555cc1-1eae-520c-189e-28548904f529',
        externalId: undefined,
        name: 'Meta description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:title (text)
       *
       * Max. 60 characters
       */
      metadata__og_title: {
        codename: 'metadata__og_title',
        id: '1db86c7a-e836-3c4e-01e6-4f704ad38ba5',
        externalId: undefined,
        name: 'og:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:description (text)
       *
       * Max. 150 characters
       */
      metadata__og_description: {
        codename: 'metadata__og_description',
        id: '05987dc9-ebe3-7b61-b949-522eb42dbc0d',
        externalId: undefined,
        name: 'og:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:image (asset)
       *
       * Use images that are at least 1200 × 630 px for best display on high resolution devices. At the minimum, you should use images that are 600 × 315 px to display link page posts with larger images. Images may be up to 1 MB in size.
       */
      metadata__og_image: {
        codename: 'metadata__og_image',
        id: 'ce6cda71-9d38-1d57-3ac3-ec9b2e286edd',
        externalId: undefined,
        name: 'og:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:site (text)
       */
      metadata__twitter_site: {
        codename: 'metadata__twitter_site',
        id: '34213fdf-0015-8f4f-e5e6-83c6842cff4a',
        externalId: undefined,
        name: 'twitter:site',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:creator (text)
       */
      metadata__twitter_creator: {
        codename: 'metadata__twitter_creator',
        id: '68f65095-c9b4-05d6-a473-2883c2f0c7af',
        externalId: undefined,
        name: 'twitter:creator',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:title (text)
       *
       * Max. 60 characters
       */
      metadata__twitter_title: {
        codename: 'metadata__twitter_title',
        id: 'b208d3dc-bd8d-b1af-5ef0-747650730ba7',
        externalId: undefined,
        name: 'twitter:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:description (text)
       *
       * A description that concisely summarizes the content as appropriate for presentation within a Tweet. You should not re-use the title as the description, or use this field to describe the general services provided by the website. Max. 150 characters.
       */
      metadata__twitter_description: {
        codename: 'metadata__twitter_description',
        id: 'b7d1dd8b-a5d8-2ad8-2f57-49881363f6f7',
        externalId: undefined,
        name: 'twitter:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:image (asset)
       *
       * Twitter's recommendation: A URL to a unique image representing the content of the page. You should not use a generic image such as your website logo, author photo, or other image that spans multiple pages. Images for this Card should be at least 280 × 150 px. Images may be up to 1 MB in size.Let's go for 560 × 300 px.
       */
      metadata__twitter_image: {
        codename: 'metadata__twitter_image',
        id: '63793ba4-6004-a93c-68ca-52a1f0482bca',
        externalId: undefined,
        name: 'twitter:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },
    },
  },

  /**
   * Article
   * Last modified: Tue Jul 16 2019 09:12:44 GMT+0200 (Středoevropský letní čas)
   */
  article: {
    codename: 'article',
    id: 'b7aa4a53-d9b1-48cf-b7a6-ed0b182c4b89',
    externalId: undefined,
    name: 'Article',
    elements: {
      /**
       * Title (text)
       *
       * The title should fit within 60 characters.Our voice and tone recommendations: — avoid coffee jargon.
       */
      title: {
        codename: 'title',
        id: '85d5efc6-f47e-2fde-a6f5-0950fe89ecd1',
        externalId: undefined,
        name: 'Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Teaser image (asset)
       *
       * Upload an image at a resolution of at least 600 × 1200 px.
       */
      teaser_image: {
        codename: 'teaser_image',
        id: '62eb9881-e222-6b81-91d2-fdf052726414',
        externalId: undefined,
        name: 'Teaser image',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Post date (date_time)
       *
       * Provide a date that will appear on the live site as the date this article was posted live. This date will also influence the order of the articles.
       */
      post_date: {
        codename: 'post_date',
        id: '4ae5f7a9-fe1f-1e8c-bfec-d321455139c4',
        externalId: undefined,
        name: 'Post date',
        required: false,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * Summary (text)
       *
       * Provide a short summary of the text. It should be catchy and make the visitor want to read the whole article.The summary should fit within 160 characters.
       */
      summary: {
        codename: 'summary',
        id: '90550cbe-7bff-40a9-2947-9c81489fe562',
        externalId: undefined,
        name: 'Summary',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Body Copy (rich_text)
       *
       * Keep the article structured with concise paragraphs complemented with headlines that will help the reader navigate through the article's content.Preferred glossary terms — coffee, brewing, grinder, drip, roast, filter.
       */
      body_copy: {
        codename: 'body_copy',
        id: '108ed7c0-fc8c-c0ec-d0b5-5a8071408b54',
        externalId: undefined,
        name: 'Body Copy',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Related articles (modular_content)
       *
       * Provide articles with related topics.
       */
      related_articles: {
        codename: 'related_articles',
        id: 'ee7c3687-b469-6c56-3ac6-c8dfdc8b58b5',
        externalId: undefined,
        name: 'Related articles',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Meta keywords (text)
       *
       * Enter tags separated with a comma. Example: coffee, "coffee roast”, grinder
       */
      meta_keywords: {
        codename: 'meta_keywords',
        id: '5efb2425-5987-a4a6-a2d3-b14712b56e73',
        externalId: undefined,
        name: 'Meta keywords',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Personas (taxonomy)
       *
       * Provide all personas for which this article is relevant.
       */
      personas: {
        codename: 'personas',
        id: '0a16b642-ac3e-584d-a45a-ba354a30b2bd',
        externalId: undefined,
        name: 'Personas',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Meta description (text)
       *
       * Sum up the blog for SEO purposes. Limit for the meta description is 160 characters.
       */
      meta_description: {
        codename: 'meta_description',
        id: 'b9dc537c-2518-e4f5-8325-ce4fce26171e',
        externalId: undefined,
        name: 'Meta description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * URL pattern (url_slug)
       *
       * Provide a SEO-friendly URL.
       */
      url_pattern: {
        codename: 'url_pattern',
        id: 'f2ff5e3f-a9ca-4604-58b0-34a2ad6a7cf1',
        externalId: undefined,
        name: 'URL pattern',
        required: false,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: 'a4d7a146-7e39-4001-b462-c5a0c734f3f5',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Meta title (text)
       *
       * Length: 30–60 characters
       */
      metadata__meta_title: {
        codename: 'metadata__meta_title',
        id: '09398b24-61ed-512e-5b5c-affd54a098e5',
        externalId: undefined,
        name: 'Meta title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * Meta description (text)
       *
       * Length: 70–150 characters
       */
      metadata__meta_description: {
        codename: 'metadata__meta_description',
        id: '2e555cc1-1eae-520c-189e-28548904f529',
        externalId: undefined,
        name: 'Meta description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:title (text)
       *
       * Max. 60 characters
       */
      metadata__og_title: {
        codename: 'metadata__og_title',
        id: '1db86c7a-e836-3c4e-01e6-4f704ad38ba5',
        externalId: undefined,
        name: 'og:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:description (text)
       *
       * Max. 150 characters
       */
      metadata__og_description: {
        codename: 'metadata__og_description',
        id: '05987dc9-ebe3-7b61-b949-522eb42dbc0d',
        externalId: undefined,
        name: 'og:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:image (asset)
       *
       * Use images that are at least 1200 × 630 px for best display on high resolution devices. At the minimum, you should use images that are 600 × 315 px to display link page posts with larger images. Images may be up to 1 MB in size.
       */
      metadata__og_image: {
        codename: 'metadata__og_image',
        id: 'ce6cda71-9d38-1d57-3ac3-ec9b2e286edd',
        externalId: undefined,
        name: 'og:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:site (text)
       */
      metadata__twitter_site: {
        codename: 'metadata__twitter_site',
        id: '34213fdf-0015-8f4f-e5e6-83c6842cff4a',
        externalId: undefined,
        name: 'twitter:site',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:creator (text)
       */
      metadata__twitter_creator: {
        codename: 'metadata__twitter_creator',
        id: '68f65095-c9b4-05d6-a473-2883c2f0c7af',
        externalId: undefined,
        name: 'twitter:creator',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:title (text)
       *
       * Max. 60 characters
       */
      metadata__twitter_title: {
        codename: 'metadata__twitter_title',
        id: 'b208d3dc-bd8d-b1af-5ef0-747650730ba7',
        externalId: undefined,
        name: 'twitter:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:description (text)
       *
       * A description that concisely summarizes the content as appropriate for presentation within a Tweet. You should not re-use the title as the description, or use this field to describe the general services provided by the website. Max. 150 characters.
       */
      metadata__twitter_description: {
        codename: 'metadata__twitter_description',
        id: 'b7d1dd8b-a5d8-2ad8-2f57-49881363f6f7',
        externalId: undefined,
        name: 'twitter:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:image (asset)
       *
       * Twitter's recommendation: A URL to a unique image representing the content of the page. You should not use a generic image such as your website logo, author photo, or other image that spans multiple pages. Images for this Card should be at least 280 × 150 px. Images may be up to 1 MB in size.Let's go for 560 × 300 px.
       */
      metadata__twitter_image: {
        codename: 'metadata__twitter_image',
        id: '63793ba4-6004-a93c-68ca-52a1f0482bca',
        externalId: undefined,
        name: 'twitter:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },
    },
  },

  /**
   * Grinder
   * Last modified: Tue Jul 16 2019 09:16:16 GMT+0200 (Středoevropský letní čas)
   */
  grinder: {
    codename: 'grinder',
    id: 'da4f1cb1-8a55-43e5-9fcc-67ad331c8888',
    externalId: undefined,
    name: 'Grinder',
    elements: {
      /**
       * Product name (text)
       *
       * Include a product display name.
       */
      product_name: {
        codename: 'product_name',
        id: 'b7b9604e-c74e-79ea-2a0f-d74d6347e35a',
        externalId: undefined,
        name: 'Product name',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Price (number)
       *
       * Include a product price.
       */
      price: {
        codename: 'price',
        id: '1e14595d-7fe8-7765-6df6-fad6a6e4851f',
        externalId: undefined,
        name: 'Price',
        required: false,
        type: 'number',
        snippetCodename: undefined,
      },

      /**
       * Image (asset)
       *
       * Upload one product image; the recommended size is 300 × 300 px.
       */
      image: {
        codename: 'image',
        id: '7fe226b9-d21f-80ff-e680-6e6f44ce044b',
        externalId: undefined,
        name: 'Image',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Manufacturer (text)
       *
       * Include a manufacturer's name.
       */
      manufacturer: {
        codename: 'manufacturer',
        id: '2c389736-7dfa-b03e-8996-7eba451cfdb5',
        externalId: undefined,
        name: 'Manufacturer',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Product status (taxonomy)
       *
       * Add a product status if the product is included in a special offering.
       */
      product_status: {
        codename: 'product_status',
        id: '54120e88-82cc-2202-e72d-9cae0ced3f51',
        externalId: undefined,
        name: 'Product status',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Short description (rich_text)
       *
       * Include a short description that fits within 160 characters.
       */
      short_description: {
        codename: 'short_description',
        id: '23ee310f-9732-9193-ad5e-80f75bfc276d',
        externalId: undefined,
        name: 'Short description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Long description (rich_text)
       *
       * Include a full product description.
       */
      long_description: {
        codename: 'long_description',
        id: '21e77286-e87b-d6e3-902d-13b5814b5e75',
        externalId: undefined,
        name: 'Long description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * URL pattern (url_slug)
       *
       * Provide a SEO-friendly URL.
       */
      url_pattern: {
        codename: 'url_pattern',
        id: 'bf6ad588-11e5-ba0d-2c18-ccd50064a32a',
        externalId: undefined,
        name: 'URL pattern',
        required: false,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: '02f0e374-6760-4b4d-99a8-60485572b764',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Meta title (text)
       *
       * Length: 30–60 characters
       */
      metadata__meta_title: {
        codename: 'metadata__meta_title',
        id: '09398b24-61ed-512e-5b5c-affd54a098e5',
        externalId: undefined,
        name: 'Meta title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * Meta description (text)
       *
       * Length: 70–150 characters
       */
      metadata__meta_description: {
        codename: 'metadata__meta_description',
        id: '2e555cc1-1eae-520c-189e-28548904f529',
        externalId: undefined,
        name: 'Meta description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:title (text)
       *
       * Max. 60 characters
       */
      metadata__og_title: {
        codename: 'metadata__og_title',
        id: '1db86c7a-e836-3c4e-01e6-4f704ad38ba5',
        externalId: undefined,
        name: 'og:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:description (text)
       *
       * Max. 150 characters
       */
      metadata__og_description: {
        codename: 'metadata__og_description',
        id: '05987dc9-ebe3-7b61-b949-522eb42dbc0d',
        externalId: undefined,
        name: 'og:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:image (asset)
       *
       * Use images that are at least 1200 × 630 px for best display on high resolution devices. At the minimum, you should use images that are 600 × 315 px to display link page posts with larger images. Images may be up to 1 MB in size.
       */
      metadata__og_image: {
        codename: 'metadata__og_image',
        id: 'ce6cda71-9d38-1d57-3ac3-ec9b2e286edd',
        externalId: undefined,
        name: 'og:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:site (text)
       */
      metadata__twitter_site: {
        codename: 'metadata__twitter_site',
        id: '34213fdf-0015-8f4f-e5e6-83c6842cff4a',
        externalId: undefined,
        name: 'twitter:site',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:creator (text)
       */
      metadata__twitter_creator: {
        codename: 'metadata__twitter_creator',
        id: '68f65095-c9b4-05d6-a473-2883c2f0c7af',
        externalId: undefined,
        name: 'twitter:creator',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:title (text)
       *
       * Max. 60 characters
       */
      metadata__twitter_title: {
        codename: 'metadata__twitter_title',
        id: 'b208d3dc-bd8d-b1af-5ef0-747650730ba7',
        externalId: undefined,
        name: 'twitter:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:description (text)
       *
       * A description that concisely summarizes the content as appropriate for presentation within a Tweet. You should not re-use the title as the description, or use this field to describe the general services provided by the website. Max. 150 characters.
       */
      metadata__twitter_description: {
        codename: 'metadata__twitter_description',
        id: 'b7d1dd8b-a5d8-2ad8-2f57-49881363f6f7',
        externalId: undefined,
        name: 'twitter:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:image (asset)
       *
       * Twitter's recommendation: A URL to a unique image representing the content of the page. You should not use a generic image such as your website logo, author photo, or other image that spans multiple pages. Images for this Card should be at least 280 × 150 px. Images may be up to 1 MB in size.Let's go for 560 × 300 px.
       */
      metadata__twitter_image: {
        codename: 'metadata__twitter_image',
        id: '63793ba4-6004-a93c-68ca-52a1f0482bca',
        externalId: undefined,
        name: 'twitter:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },
    },
  },

  /**
   * Office
   * Last modified: Wed Mar 27 2019 14:07:06 GMT+0100 (Středoevropský standardní čas)
   */
  office: {
    codename: 'office',
    id: 'e097306b-3893-4a42-9973-2525fad14d66',
    externalId: undefined,
    name: 'Office',
    elements: {
      /**
       * Name (text)
       */
      name: {
        codename: 'name',
        id: 'bb81a11d-886c-2a32-e480-29f01cea667f',
        externalId: undefined,
        name: 'Name',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Street (text)
       */
      street: {
        codename: 'street',
        id: 'f7eb7ab2-4e41-aca0-7e93-dbbbdca330eb',
        externalId: undefined,
        name: 'Street',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * City (text)
       */
      city: {
        codename: 'city',
        id: '95477abc-d6b4-a6b3-5b72-c92763da55bf',
        externalId: undefined,
        name: 'City',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Country (text)
       */
      country: {
        codename: 'country',
        id: '4fbc7779-652d-7716-2673-7419aaaceed1',
        externalId: undefined,
        name: 'Country',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * State (text)
       */
      state: {
        codename: 'state',
        id: '08df2f10-52b8-d451-fab1-b6da8ddb3fd2',
        externalId: undefined,
        name: 'State',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Zip code (text)
       */
      zip_code: {
        codename: 'zip_code',
        id: 'e7141da8-8792-a66d-d1c8-1fe704758393',
        externalId: undefined,
        name: 'Zip code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Phone (text)
       */
      phone: {
        codename: 'phone',
        id: '2ac708e2-cd0e-67b0-67f8-71725625dc6d',
        externalId: undefined,
        name: 'Phone',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Email (text)
       */
      email: {
        codename: 'email',
        id: '251dc38f-43a3-d924-a328-8708ecb00ef1',
        externalId: undefined,
        name: 'Email',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: '93e978da-a9dd-43eb-a16a-ace55c1a5245',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * Tweet
   * Last modified: Fri Mar 29 2019 14:55:38 GMT+0100 (Středoevropský standardní čas)
   */
  tweet: {
    codename: 'tweet',
    id: 'f808c142-4b62-43b0-8f4d-1cbf412580ab',
    externalId: undefined,
    name: 'Tweet',
    elements: {
      /**
       * Tweet link (text)
       */
      tweet_link: {
        codename: 'tweet_link',
        id: '20bf9ba1-28fe-203c-5920-6f9610498fb9',
        externalId: undefined,
        name: 'Tweet link',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Theme (multiple_choice)
       */
      theme: {
        codename: 'theme',
        id: '779b27fd-5a4d-5e5f-66dc-b30931fcba92',
        externalId: undefined,
        name: 'Theme',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Display options (multiple_choice)
       */
      display_options: {
        codename: 'display_options',
        id: '8c6db6cf-1003-951e-5407-b2a19c15b4cd',
        externalId: undefined,
        name: 'Display options',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * Cafe
   * Last modified: Wed Mar 27 2019 14:05:05 GMT+0100 (Středoevropský standardní čas)
   */
  cafe: {
    codename: 'cafe',
    id: 'fe41ae5a-5fe2-420a-8560-f7d6d3533dc2',
    externalId: undefined,
    name: 'Cafe',
    elements: {
      /**
       * Street (text)
       */
      street: {
        codename: 'street',
        id: '866afdba-d334-f01a-1d52-a9ca3f57cb4b',
        externalId: undefined,
        name: 'Street',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * City (text)
       */
      city: {
        codename: 'city',
        id: '339e6d4f-67c1-5f5e-6921-3b374eb96f5b',
        externalId: undefined,
        name: 'City',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Country (text)
       */
      country: {
        codename: 'country',
        id: '7531a08f-e148-8cc0-9d2d-155215502e08',
        externalId: undefined,
        name: 'Country',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * State (text)
       */
      state: {
        codename: 'state',
        id: 'a015b689-cad3-1ac9-04b4-73697525752d',
        externalId: undefined,
        name: 'State',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ZIP Code (text)
       */
      zip_code: {
        codename: 'zip_code',
        id: 'bb158ac2-41e1-5a7d-0826-bb8bf6744f0e',
        externalId: undefined,
        name: 'ZIP Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Phone (text)
       */
      phone: {
        codename: 'phone',
        id: '1c71bc62-4b62-f307-37ef-0823776f8f73',
        externalId: undefined,
        name: 'Phone',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Email (text)
       */
      email: {
        codename: 'email',
        id: '6f726c77-36bd-8062-51df-056136e10d35',
        externalId: undefined,
        name: 'Email',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Photo (asset)
       */
      photo: {
        codename: 'photo',
        id: '5769c0f4-66a8-4c73-3c19-c023bdfa123a',
        externalId: undefined,
        name: 'Photo',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: 'e82d0f49-5b15-45e1-9b1f-32ccc1be4941',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * Home
   * Last modified: Tue Jul 16 2019 09:16:46 GMT+0200 (Středoevropský letní čas)
   */
  home: {
    codename: 'home',
    id: 'a29399c3-5281-47ab-9916-acd4a6f887b7',
    externalId: undefined,
    name: 'Home',
    elements: {
      /**
       * Hero unit (modular_content)
       *
       * Assign 1 Hero unit that has been prepared for a home page.
       */
      hero_unit: {
        codename: 'hero_unit',
        id: '2b15a8f3-2e5f-7d01-4d8e-5b22e222aa76',
        externalId: undefined,
        name: 'Hero unit',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Articles (modular_content)
       *
       * Assign all articles which should be displayed on the home page.
       */
      articles: {
        codename: 'articles',
        id: '222f3a69-a54f-3e92-83ac-05f8a08e667f',
        externalId: undefined,
        name: 'Articles',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Our story (modular_content)
       *
       * Assign 1 Fact about us which will be displayed on the home page.
       */
      our_story: {
        codename: 'our_story',
        id: '617bccc0-4844-4beb-4ede-6247e954633a',
        externalId: undefined,
        name: 'Our story',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Cafes (modular_content)
       *
       * Assign 4 Cafes which will be displayed on the home page.
       */
      cafes: {
        codename: 'cafes',
        id: '6356c948-0fd6-00d0-8fc1-e2484180ae7c',
        externalId: undefined,
        name: 'Cafes',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Contact (rich_text)
       *
       * Add Contact us information to be displayed on the home page.
       */
      contact: {
        codename: 'contact',
        id: 'ee854076-236b-5312-0ed5-8c3cd55ca9e0',
        externalId: undefined,
        name: 'Contact',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * URL pattern (url_slug)
       *
       * Provide a SEO-friendly URL.
       */
      url_pattern: {
        codename: 'url_pattern',
        id: 'dd70db4b-ee97-5ab4-b752-4f9d70389426',
        externalId: undefined,
        name: 'URL pattern',
        required: false,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: 'ea3bf3c2-7eb7-4c91-aff3-09f89c743710',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Meta title (text)
       *
       * Length: 30–60 characters
       */
      metadata__meta_title: {
        codename: 'metadata__meta_title',
        id: '09398b24-61ed-512e-5b5c-affd54a098e5',
        externalId: undefined,
        name: 'Meta title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * Meta description (text)
       *
       * Length: 70–150 characters
       */
      metadata__meta_description: {
        codename: 'metadata__meta_description',
        id: '2e555cc1-1eae-520c-189e-28548904f529',
        externalId: undefined,
        name: 'Meta description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:title (text)
       *
       * Max. 60 characters
       */
      metadata__og_title: {
        codename: 'metadata__og_title',
        id: '1db86c7a-e836-3c4e-01e6-4f704ad38ba5',
        externalId: undefined,
        name: 'og:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:description (text)
       *
       * Max. 150 characters
       */
      metadata__og_description: {
        codename: 'metadata__og_description',
        id: '05987dc9-ebe3-7b61-b949-522eb42dbc0d',
        externalId: undefined,
        name: 'og:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:image (asset)
       *
       * Use images that are at least 1200 × 630 px for best display on high resolution devices. At the minimum, you should use images that are 600 × 315 px to display link page posts with larger images. Images may be up to 1 MB in size.
       */
      metadata__og_image: {
        codename: 'metadata__og_image',
        id: 'ce6cda71-9d38-1d57-3ac3-ec9b2e286edd',
        externalId: undefined,
        name: 'og:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:site (text)
       */
      metadata__twitter_site: {
        codename: 'metadata__twitter_site',
        id: '34213fdf-0015-8f4f-e5e6-83c6842cff4a',
        externalId: undefined,
        name: 'twitter:site',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:creator (text)
       */
      metadata__twitter_creator: {
        codename: 'metadata__twitter_creator',
        id: '68f65095-c9b4-05d6-a473-2883c2f0c7af',
        externalId: undefined,
        name: 'twitter:creator',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:title (text)
       *
       * Max. 60 characters
       */
      metadata__twitter_title: {
        codename: 'metadata__twitter_title',
        id: 'b208d3dc-bd8d-b1af-5ef0-747650730ba7',
        externalId: undefined,
        name: 'twitter:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:description (text)
       *
       * A description that concisely summarizes the content as appropriate for presentation within a Tweet. You should not re-use the title as the description, or use this field to describe the general services provided by the website. Max. 150 characters.
       */
      metadata__twitter_description: {
        codename: 'metadata__twitter_description',
        id: 'b7d1dd8b-a5d8-2ad8-2f57-49881363f6f7',
        externalId: undefined,
        name: 'twitter:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:image (asset)
       *
       * Twitter's recommendation: A URL to a unique image representing the content of the page. You should not use a generic image such as your website logo, author photo, or other image that spans multiple pages. Images for this Card should be at least 280 × 150 px. Images may be up to 1 MB in size.Let's go for 560 × 300 px.
       */
      metadata__twitter_image: {
        codename: 'metadata__twitter_image',
        id: '63793ba4-6004-a93c-68ca-52a1f0482bca',
        externalId: undefined,
        name: 'twitter:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },
    },
  },

  /**
   * Accessory
   * Last modified: Tue Jul 16 2019 09:11:09 GMT+0200 (Středoevropský letní čas)
   */
  accessory: {
    codename: 'accessory',
    id: 'd9748663-f567-4c51-a922-c24a1d6b935a',
    externalId: undefined,
    name: 'Accessory',
    elements: {
      /**
       * Product name (text)
       *
       * Include a product display name.
       */
      product_name: {
        codename: 'product_name',
        id: 'f9e2672c-5035-412e-3985-d6112b3781bd',
        externalId: undefined,
        name: 'Product name',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Price (number)
       *
       * Include a product price.
       */
      price: {
        codename: 'price',
        id: '51d63ac3-d40d-15ea-c219-be207714077c',
        externalId: undefined,
        name: 'Price',
        required: false,
        type: 'number',
        snippetCodename: undefined,
      },

      /**
       * Image (asset)
       *
       * Upload one product image; the recommended size is 300 × 300 px.
       */
      image: {
        codename: 'image',
        id: 'f0db12e6-86e4-8597-903b-c5984076d6b3',
        externalId: undefined,
        name: 'Image',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Manufacturer (text)
       *
       * Include a manufacturer's name.
       */
      manufacturer: {
        codename: 'manufacturer',
        id: 'ab75ff46-b629-5ce5-aac9-79ed8a7b869c',
        externalId: undefined,
        name: 'Manufacturer',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Product status (taxonomy)
       *
       * Add a product status if the product is included in a special offering.
       */
      product_status: {
        codename: 'product_status',
        id: 'ef13b1f4-b558-f707-35a4-86146dbe4518',
        externalId: undefined,
        name: 'Product status',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Short description (rich_text)
       *
       * Include a short description that fits within 160 characters.
       */
      short_description: {
        codename: 'short_description',
        id: '9740e2d0-87e8-52f5-ff4c-566fa00b1253',
        externalId: undefined,
        name: 'Short description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Long description (rich_text)
       *
       * Include a full product description.
       */
      long_description: {
        codename: 'long_description',
        id: '1f961774-a589-4e21-9f8e-a8c4908ea476',
        externalId: undefined,
        name: 'Long description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * URL pattern (url_slug)
       *
       * Provide a SEO-friendly URL.
       */
      url_pattern: {
        codename: 'url_pattern',
        id: '69e4af48-f1ac-1146-e6c9-d20d55ca5792',
        externalId: undefined,
        name: 'URL pattern',
        required: false,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: 'd8ed1597-930c-4cf8-a34e-c5d5e82718ed',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Meta title (text)
       *
       * Length: 30–60 characters
       */
      metadata__meta_title: {
        codename: 'metadata__meta_title',
        id: '09398b24-61ed-512e-5b5c-affd54a098e5',
        externalId: undefined,
        name: 'Meta title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * Meta description (text)
       *
       * Length: 70–150 characters
       */
      metadata__meta_description: {
        codename: 'metadata__meta_description',
        id: '2e555cc1-1eae-520c-189e-28548904f529',
        externalId: undefined,
        name: 'Meta description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:title (text)
       *
       * Max. 60 characters
       */
      metadata__og_title: {
        codename: 'metadata__og_title',
        id: '1db86c7a-e836-3c4e-01e6-4f704ad38ba5',
        externalId: undefined,
        name: 'og:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:description (text)
       *
       * Max. 150 characters
       */
      metadata__og_description: {
        codename: 'metadata__og_description',
        id: '05987dc9-ebe3-7b61-b949-522eb42dbc0d',
        externalId: undefined,
        name: 'og:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:image (asset)
       *
       * Use images that are at least 1200 × 630 px for best display on high resolution devices. At the minimum, you should use images that are 600 × 315 px to display link page posts with larger images. Images may be up to 1 MB in size.
       */
      metadata__og_image: {
        codename: 'metadata__og_image',
        id: 'ce6cda71-9d38-1d57-3ac3-ec9b2e286edd',
        externalId: undefined,
        name: 'og:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:site (text)
       */
      metadata__twitter_site: {
        codename: 'metadata__twitter_site',
        id: '34213fdf-0015-8f4f-e5e6-83c6842cff4a',
        externalId: undefined,
        name: 'twitter:site',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:creator (text)
       */
      metadata__twitter_creator: {
        codename: 'metadata__twitter_creator',
        id: '68f65095-c9b4-05d6-a473-2883c2f0c7af',
        externalId: undefined,
        name: 'twitter:creator',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:title (text)
       *
       * Max. 60 characters
       */
      metadata__twitter_title: {
        codename: 'metadata__twitter_title',
        id: 'b208d3dc-bd8d-b1af-5ef0-747650730ba7',
        externalId: undefined,
        name: 'twitter:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:description (text)
       *
       * A description that concisely summarizes the content as appropriate for presentation within a Tweet. You should not re-use the title as the description, or use this field to describe the general services provided by the website. Max. 150 characters.
       */
      metadata__twitter_description: {
        codename: 'metadata__twitter_description',
        id: 'b7d1dd8b-a5d8-2ad8-2f57-49881363f6f7',
        externalId: undefined,
        name: 'twitter:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:image (asset)
       *
       * Twitter's recommendation: A URL to a unique image representing the content of the page. You should not use a generic image such as your website logo, author photo, or other image that spans multiple pages. Images for this Card should be at least 280 × 150 px. Images may be up to 1 MB in size.Let's go for 560 × 300 px.
       */
      metadata__twitter_image: {
        codename: 'metadata__twitter_image',
        id: '63793ba4-6004-a93c-68ca-52a1f0482bca',
        externalId: undefined,
        name: 'twitter:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },
    },
  },

  /**
   * Brewer
   * Last modified: Tue Jul 16 2019 09:15:27 GMT+0200 (Středoevropský letní čas)
   */
  brewer: {
    codename: 'brewer',
    id: '7bc932b3-ce2a-4aa7-954e-04cbcbd214fc',
    externalId: undefined,
    name: 'Brewer',
    elements: {
      /**
       * Product name (text)
       *
       * Include a product display name.
       */
      product_name: {
        codename: 'product_name',
        id: '01d6c6c7-92ff-a675-e413-861e5a9a4034',
        externalId: undefined,
        name: 'Product name',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Price (number)
       *
       * Include a product price.
       */
      price: {
        codename: 'price',
        id: '48ebe0fc-afe7-2b93-d351-0e352332bc52',
        externalId: undefined,
        name: 'Price',
        required: false,
        type: 'number',
        snippetCodename: undefined,
      },

      /**
       * Image (asset)
       *
       * Upload one product image; the recommended size is 300 × 300 px.
       */
      image: {
        codename: 'image',
        id: 'd0c1e9e7-7d5d-e61f-8564-56a8cb758cb8',
        externalId: undefined,
        name: 'Image',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Product status (taxonomy)
       *
       * Add a product status if the product is included in a special offering.
       */
      product_status: {
        codename: 'product_status',
        id: '960d0011-ff3b-41ac-1447-8eac6ee66eaa',
        externalId: undefined,
        name: 'Product status',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Short description (rich_text)
       *
       * Include a short description that fits within 160 characters.
       */
      short_description: {
        codename: 'short_description',
        id: '8c235a7f-034e-f803-e612-9c47c8a49506',
        externalId: undefined,
        name: 'Short description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Long description (rich_text)
       *
       * Include a full product description.
       */
      long_description: {
        codename: 'long_description',
        id: '14510bef-fd86-7d5d-992a-c1e091cbcb97',
        externalId: undefined,
        name: 'Long description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * URL pattern (url_slug)
       *
       * Provide a SEO-friendly URL.
       */
      url_pattern: {
        codename: 'url_pattern',
        id: '737c85be-f532-c8fe-a308-2a0f2c512f3e',
        externalId: undefined,
        name: 'URL pattern',
        required: false,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * Manufacturer (taxonomy)
       */
      manufacturer: {
        codename: 'manufacturer',
        id: '53b6bddb-fe8a-a8b2-9765-343479bf9fc2',
        externalId: undefined,
        name: 'Manufacturer',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: '7632f3bb-2e53-438d-933c-4e8b6c035cb1',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Meta title (text)
       *
       * Length: 30–60 characters
       */
      metadata__meta_title: {
        codename: 'metadata__meta_title',
        id: '09398b24-61ed-512e-5b5c-affd54a098e5',
        externalId: undefined,
        name: 'Meta title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * Meta description (text)
       *
       * Length: 70–150 characters
       */
      metadata__meta_description: {
        codename: 'metadata__meta_description',
        id: '2e555cc1-1eae-520c-189e-28548904f529',
        externalId: undefined,
        name: 'Meta description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:title (text)
       *
       * Max. 60 characters
       */
      metadata__og_title: {
        codename: 'metadata__og_title',
        id: '1db86c7a-e836-3c4e-01e6-4f704ad38ba5',
        externalId: undefined,
        name: 'og:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:description (text)
       *
       * Max. 150 characters
       */
      metadata__og_description: {
        codename: 'metadata__og_description',
        id: '05987dc9-ebe3-7b61-b949-522eb42dbc0d',
        externalId: undefined,
        name: 'og:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:image (asset)
       *
       * Use images that are at least 1200 × 630 px for best display on high resolution devices. At the minimum, you should use images that are 600 × 315 px to display link page posts with larger images. Images may be up to 1 MB in size.
       */
      metadata__og_image: {
        codename: 'metadata__og_image',
        id: 'ce6cda71-9d38-1d57-3ac3-ec9b2e286edd',
        externalId: undefined,
        name: 'og:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:site (text)
       */
      metadata__twitter_site: {
        codename: 'metadata__twitter_site',
        id: '34213fdf-0015-8f4f-e5e6-83c6842cff4a',
        externalId: undefined,
        name: 'twitter:site',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:creator (text)
       */
      metadata__twitter_creator: {
        codename: 'metadata__twitter_creator',
        id: '68f65095-c9b4-05d6-a473-2883c2f0c7af',
        externalId: undefined,
        name: 'twitter:creator',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:title (text)
       *
       * Max. 60 characters
       */
      metadata__twitter_title: {
        codename: 'metadata__twitter_title',
        id: 'b208d3dc-bd8d-b1af-5ef0-747650730ba7',
        externalId: undefined,
        name: 'twitter:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:description (text)
       *
       * A description that concisely summarizes the content as appropriate for presentation within a Tweet. You should not re-use the title as the description, or use this field to describe the general services provided by the website. Max. 150 characters.
       */
      metadata__twitter_description: {
        codename: 'metadata__twitter_description',
        id: 'b7d1dd8b-a5d8-2ad8-2f57-49881363f6f7',
        externalId: undefined,
        name: 'twitter:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:image (asset)
       *
       * Twitter's recommendation: A URL to a unique image representing the content of the page. You should not use a generic image such as your website logo, author photo, or other image that spans multiple pages. Images for this Card should be at least 280 × 150 px. Images may be up to 1 MB in size.Let's go for 560 × 300 px.
       */
      metadata__twitter_image: {
        codename: 'metadata__twitter_image',
        id: '63793ba4-6004-a93c-68ca-52a1f0482bca',
        externalId: undefined,
        name: 'twitter:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },
    },
  },

  /**
   * About us
   * Last modified: Tue Jul 16 2019 09:07:38 GMT+0200 (Středoevropský letní čas)
   */
  about_us: {
    codename: 'about_us',
    id: 'b2c14f2c-6467-460b-a70b-bca17972a33a',
    externalId: undefined,
    name: 'About us',
    elements: {
      /**
       * Facts (modular_content)
       *
       * Assign all facts about our company which will be displayed on the about us page.
       */
      facts: {
        codename: 'facts',
        id: 'cff560dc-ed24-7036-cbb6-b7a1b61b196a',
        externalId: undefined,
        name: 'Facts',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * URL pattern (url_slug)
       *
       * Provide a SEO-friendly URL.
       */
      url_pattern: {
        codename: 'url_pattern',
        id: '50cb9acf-45f5-a186-5c00-9a9e4a37d84a',
        externalId: undefined,
        name: 'URL pattern',
        required: false,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: '65911e49-7bb0-41ca-9d17-ab218135126d',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Meta title (text)
       *
       * Length: 30–60 characters
       */
      metadata__meta_title: {
        codename: 'metadata__meta_title',
        id: '09398b24-61ed-512e-5b5c-affd54a098e5',
        externalId: undefined,
        name: 'Meta title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * Meta description (text)
       *
       * Length: 70–150 characters
       */
      metadata__meta_description: {
        codename: 'metadata__meta_description',
        id: '2e555cc1-1eae-520c-189e-28548904f529',
        externalId: undefined,
        name: 'Meta description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:title (text)
       *
       * Max. 60 characters
       */
      metadata__og_title: {
        codename: 'metadata__og_title',
        id: '1db86c7a-e836-3c4e-01e6-4f704ad38ba5',
        externalId: undefined,
        name: 'og:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:description (text)
       *
       * Max. 150 characters
       */
      metadata__og_description: {
        codename: 'metadata__og_description',
        id: '05987dc9-ebe3-7b61-b949-522eb42dbc0d',
        externalId: undefined,
        name: 'og:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * og:image (asset)
       *
       * Use images that are at least 1200 × 630 px for best display on high resolution devices. At the minimum, you should use images that are 600 × 315 px to display link page posts with larger images. Images may be up to 1 MB in size.
       */
      metadata__og_image: {
        codename: 'metadata__og_image',
        id: 'ce6cda71-9d38-1d57-3ac3-ec9b2e286edd',
        externalId: undefined,
        name: 'og:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:site (text)
       */
      metadata__twitter_site: {
        codename: 'metadata__twitter_site',
        id: '34213fdf-0015-8f4f-e5e6-83c6842cff4a',
        externalId: undefined,
        name: 'twitter:site',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:creator (text)
       */
      metadata__twitter_creator: {
        codename: 'metadata__twitter_creator',
        id: '68f65095-c9b4-05d6-a473-2883c2f0c7af',
        externalId: undefined,
        name: 'twitter:creator',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:title (text)
       *
       * Max. 60 characters
       */
      metadata__twitter_title: {
        codename: 'metadata__twitter_title',
        id: 'b208d3dc-bd8d-b1af-5ef0-747650730ba7',
        externalId: undefined,
        name: 'twitter:title',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:description (text)
       *
       * A description that concisely summarizes the content as appropriate for presentation within a Tweet. You should not re-use the title as the description, or use this field to describe the general services provided by the website. Max. 150 characters.
       */
      metadata__twitter_description: {
        codename: 'metadata__twitter_description',
        id: 'b7d1dd8b-a5d8-2ad8-2f57-49881363f6f7',
        externalId: undefined,
        name: 'twitter:description',
        required: false,
        type: 'text',
        snippetCodename: 'metadata',
      },

      /**
       * twitter:image (asset)
       *
       * Twitter's recommendation: A URL to a unique image representing the content of the page. You should not use a generic image such as your website logo, author photo, or other image that spans multiple pages. Images for this Card should be at least 280 × 150 px. Images may be up to 1 MB in size.Let's go for 560 × 300 px.
       */
      metadata__twitter_image: {
        codename: 'metadata__twitter_image',
        id: '63793ba4-6004-a93c-68ca-52a1f0482bca',
        externalId: undefined,
        name: 'twitter:image',
        required: false,
        type: 'asset',
        snippetCodename: 'metadata',
      },
    },
  },

  /**
   * Fact about us
   * Last modified: Wed Mar 27 2019 14:05:49 GMT+0100 (Středoevropský standardní čas)
   */
  fact_about_us: {
    codename: 'fact_about_us',
    id: 'b99ec220-0f2b-4658-a080-ff0afe92f6d1',
    externalId: undefined,
    name: 'Fact about us',
    elements: {
      /**
       * Title (text)
       *
       * Provide a title that fits within 60 characters.
       */
      title: {
        codename: 'title',
        id: '2375ca8a-43d2-7282-162c-922a6fdeba3e',
        externalId: undefined,
        name: 'Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Description (rich_text)
       *
       * Include a main goal of our business. The limit is 80 characters.
       */
      description: {
        codename: 'description',
        id: '1b658e81-88c9-73d1-374d-7a60e3756ef7',
        externalId: undefined,
        name: 'Description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Image (asset)
       *
       * Attach a teaser image; max. dimensions are 1280 × 600 px; allowed formats are *.jpg, *.png, *.gif.
       */
      image: {
        codename: 'image',
        id: '68d194b6-efad-6b25-89a4-2dfc75fed5a5',
        externalId: undefined,
        name: 'Image',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Sitemap (taxonomy)
       */
      sitemap: {
        codename: 'sitemap',
        id: '23a715f9-755c-4b9d-b6b3-e02fc1b09b83',
        externalId: undefined,
        name: 'Sitemap',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },
};
